// extracted by mini-css-extract-plugin
export default {"page":"style_page__iYpJc","container":"style_container__flBLZ"};